import Vue from 'vue';
import Router from 'vue-router';
import { getToken } from '@/utils/auth';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: r => require.ensure([], () => r(require('@/pages/login/index.vue')), 'Login'),
      meta: {
        title: '登录 - BeesFPD标准助手'
      }
    },
    {
      path: '/',
      component: r => require.ensure([], () => r(require('@/layouts/MainLayout.vue')), 'MainLayout'),
      redirect: '/compliance-assistant',
      children: [
        {
          path: 'compliance-assistant',
          name: 'ComplianceAssistant',
          component: r => require.ensure([], () => r(require('@/pages/compliance-assistant/index.vue')), 'ComplianceAssistant'),
          meta: {
            title: 'BeesFPD 智能规范助手 - 工程师的标准规范查询工具',
            description: '标准规范·一问直达：内置建/构/给排水/电气/暖通等专业最新规范，提问即可自动定位对应条文与页码。'
          }
        },
        {
          path: 'graph-assistant',
          name: 'GraphAssistant',
          component: r => require.ensure([], () => r(require('@/pages/graph-assistant/index.vue')), 'GraphAssistant'),
          meta: {
            title: 'BeesFPD 智能图例助手 - 工程师的建筑图例搜索工具',
            description: '图集图例·一问直达：内置建/构/给排水/电气/暖通等专业最新图例，提问即可查找匹配的图例图集。'
          }
        },
        {
          path: 'atlas-assistant',
          name: 'AtlasAssistant',
          component: r => require.ensure([], () => r(require('@/pages/atlas-assistant/index.vue')), 'AtlasAssistant'),
          meta: {
            title: 'BeesFPD 标准图集助手 - 建筑图集一问直达',
            description: '标准图集·一问直达：覆盖建筑/消防/给排水/电气/暖通图集，快速检索匹配的标准图集与图例。'
          }
        },
        {
          path: 'curtain-assistant',
          name: 'CurtainAssistant',
          component: r => require.ensure([], () => r(require('@/pages/curtain-assistant/index.vue')), 'CurtainAssistant'),
          meta: {
            title: 'BeesFPD 幕墙规范助手 - 面向幕墙工程的规范问答工具',
            description: '幕墙规范一问直达：覆盖幕墙设计、施工、验收及材料标准，帮助你快速定位对应规范条文与要点。'
          }
        }
      ]
    },

    {
      path: '*',
      redirect: '/compliance-assistant'
    }
  ]
});

// 白名单页面：不需要登录即可访问
// const whiteList = ['/login'];

// 路由守卫：当前只处理页面标题和 token
router.beforeEach((to, from, next) => {
  // 防止重复跳转造成死循环
  if (from.path === to.path && from.path !== '/') {
    next();
    return;
  }

  // 统一处理登录回跳：跳去 /login 时自动携带来源路由
  if (
    to.path === '/login' &&
    (!to.query || !to.query.redirect) &&
    from &&
    from.path &&
    from.path !== '/login'
  ) {
    next({
      path: '/login',
      query: Object.assign({}, to.query, { redirect: from.fullPath || '/' }),
      replace: true
    });
    return;
  }

  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  let metaDescription = document.querySelector('meta[name="description"]');
  if (to.meta && to.meta.description) {
    if (metaDescription) {
      metaDescription.setAttribute('content', to.meta.description);
    } else {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      metaDescription.setAttribute('content', to.meta.description);
      document.getElementsByTagName('head')[0].appendChild(metaDescription);
    }
  } else if (metaDescription) {
    metaDescription.setAttribute('content', 'BeesFPD 智能助手 - 工程师的标准规范和图例查询工具');
  }

  getToken();
  next();
});

export default router;





// WEBPACK FOOTER //
// ./src/router/index.js